import React from 'react';
import styled from 'styled-components';
import { Typography } from '../../../../atoms/typography/Typography';
// import { Checkbox } from '../../../../atoms/checkbox/Checkbox';
import { Radio } from '../../../../atoms/radio/Radio';
import colors from '../../../../../../tailwind.colors';

const StyledBox = styled.div`
  background-color: ${(props) =>
    props.$selected ? colors.primary[50] : 'white'};
  &:hover {
    div > svg {
      color: ${colors.primary[700]};
    }
  }
`;

const ImageBox = styled.div`
  svg {
    color: ${(props) => (props.$selected ? colors.primary[700] : 'black')};
  }
`;

export const ServiceType = ({ type, selected, onTypeSelect }) => (
  <div
    key={type.id}
    className="flex flex-col gap-2 md:gap-5 items-center justify-center flex-1 h-full"
  >
    <StyledBox
      onClick={() => onTypeSelect(type.id)}
      $selected={selected}
      className="flex flex-col gap-5 justify-center items-center h-36 w-full border border-customGray-300 cursor-pointer rounded-2xl hover:shadow-lg"
    >
      <ImageBox $selected={selected}>{type.icon}</ImageBox>
      <Radio
        value={selected}
        checked={selected}
        onChange={() => onTypeSelect(type.id)}
      />
      {/* <Checkbox
        value={selected}
        checked={selected}
        onChange={() => onTypeSelect(index + 1)}
      /> */}
    </StyledBox>
    <Typography fontVariant="md" className="w-fit leading-none">
      {type.title}
    </Typography>
  </div>
);
